export default __webpack_public_path__ + "static/DesktopMediaMainBanner-7e3e65b132cb956069d124b37300bb79.webp";